import {Button, Drawer, Dropdown} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {cloneElement, useState} from "react";
import {useClipboard} from "../../contexts/ClipboardContext";
import {useIsSmallScreen} from "../../utils/useMediaQuery";
import './grid-dropdown.css';

// width  : buton genişliği. Varsayılan 70px, çünkü çağıranların çoğu bir GUID
//          gösteriyor ve orada tam metin zaten sığmaz. Tarih gibi kısa ve tamamı
//          okunması gereken değerlerde 'auto' (içeriğe göre) ver.
// tail   : true iken metnin SONU gösterilir (GUID'lerde ayırt edici kısım sondadır);
//          tarih gibi baştan okunan değerlerde false ver.
export default function RowMenu({children, text, width = 70, tail = true})
{
    const { addText } = useClipboard();

    // Dar ekranda menü açılır katman olarak KULLANILAMIYOR: satırları sabit piksel
    // genişlikli kontrollerden kurulu (etiket + butonlar, 250px'lik Select), alt
    // menüler yana uçan ikinci bir katman açıyor ve tetikleyen buton zaten ekranın
    // sağ yarısında olduğu için katman ekran dışında kalıyordu. Bu genişlikte menü
    // alttan açılan bir çekmeceye taşınır: tam genişlik, alt menüler yerinde açılır.
    // Eşik uygulamanın geri kalanıyla aynı (992).
    const isSmallScreen = useIsSmallScreen(992);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const renderButton = (onClick) => {
        const stop = (e) => {
            e.preventDefault()
            e.stopPropagation()
            onClick && onClick()
        }

        if(text)
            return (
                <Button
                    size="small"
                    style={{
                        width: width,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    onClick={stop}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        // Düz sağ tık: geçmişi temizle, sadece bu değeri tut.
                        // Ctrl (veya ⌘) basılıysa: geçmişe ekle.
                        addText(text, { reset: !(e.ctrlKey || e.metaKey) });
                    }}
                    title={text}
                >
                    <span style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        direction: tail ? 'rtl' : 'ltr',
                        textAlign: 'left'
                    }}>
                        {text}
                    </span>
                </Button>
            )

        return (
            <Button onClick={stop}>
                <DownOutlined />
            </Button>
        )
    }

    if(isSmallScreen)
    {
        // Bir menü satırına dokunulunca çekmece kapanır — AMA kendi açılırını yöneten
        // kontroller (Select, tarih, metin kutusu) ve yalnızca alt menüyü açıp kapatan
        // başlıklar kapatmaz; yoksa çekmece, seçim yapılmadan kapanırdı.
        const onContentClick = (e) => {
            const el = e.target;
            if(!el || typeof el.closest !== 'function') return;
            if(el.closest('.ant-select, .ant-picker, .ant-switch, input, textarea')) return;
            if(el.closest('.ant-menu-submenu-title')) return;
            if(el.closest('.ant-menu-item')) setDrawerOpen(false);
        }

        return (
            <>
                {renderButton(() => setDrawerOpen(true))}
                <Drawer
                    // rootClassName: maske de aynı sınıfı taşısın — satır detay çekmecesinin
                    // "dışarı tıklayınca kapan" kuralı bu menüyü kendi dışı saymasın.
                    rootClassName={'grid-dropdown-drawer'}
                    placement={'bottom'}
                    height={'auto'}
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    title={text}
                    styles={{ body: { padding: 0, maxHeight: '70vh', overflowY: 'auto' } }}
                >
                    <div onClick={onContentClick}>
                        {cloneElement(children, {
                            mode: 'inline',
                            selectable: false,
                            inlineIndent: 16,
                            style: { border: 'none' }
                        })}
                    </div>
                </Drawer>
            </>
        )
    }

    return (
        <Dropdown trigger={'click'} overlay={children} overlayClassName={'grid-dropdown-overlay'}>
            {renderButton()}
        </Dropdown>
    )
}
